import { Decorate } from './types';

/*
 * Decorate Default
 */
export default class Default extends Decorate {}
